import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { PricingService } from '../../../services/pricing.service';
import { PictureComponent } from '../../../shared/components/picture/picture.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ResizeDirective } from '../../../shared/directives/resize.directive';

@Component({
  selector: 'app-pre-footer',
  standalone: true,
  templateUrl: './pre-footer.component.html',
  styleUrls: ['./pre-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SvgComponent, ResizeDirective, PictureComponent],
})
export class PreFooterComponent {
  @Input() dark: boolean;
  @Input() black: boolean;
  @Input() title = 'Experience Picflow with a Free Trial';
  @Input() darkImage: string;
  @Input() lightImage: string;
  trialLengthDays: number;

  private pricingService = inject(PricingService);

  defaultDarkImage = 'https://a.storyblok.com/f/234504/1920x960/dcb5b2eca1/pre-footer-desktop-dark.webp';
  defaultLightImage = 'https://a.storyblok.com/f/234504/1920x960/15dfb5095b/pre-footer-desktop-light.webp';

  constructor() {
    this.trialLengthDays = this.pricingService.getTrialLengthDays();
  }
}
